export default __webpack_public_path__ + "static/media/nokia-logo-white.b0396cee.svg";